module.exports = __webpack_public_path__ + "static/img/langenkamp.8dda2a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WED_Langenkamp/langenkamp.jpg
// module id = oHFg
// module chunks = 0